import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
    IconSize,
    IconType,
    InvitationSource,
    Person,
    ScheduledAssessmentDetails
} from '../../core-data-model';
import { TranslationService } from '../../translations';

@Component({
    selector: 'create-person-form',
    template: `
        <div class="createPerson_container border-color-primary-300">
            <div class="layoutLastPushedRight-X">
                <div class="layoutVertical">
                    <span class="largeLabelText" style="margin: 5px 0px 5px">{{
                        TR.key('assessmentcenter.createnewperson')
                    }}</span>
                    <span class="smallText" style="margin: 0px 0px 10px">
                        {{ TR.key('teams.sendBA-description') }}
                    </span>
                </div>
                <button
                    type="button"
                    class="close pushElementRight"
                    (click)="close.emit()"
                    [title]="TR.key('text.common-terms.close')"
                >
                    <abstract-icon [iconType]="IconType.Close"></abstract-icon>
                </button>
            </div>

            <create-person-with-BA
                (createdPerson)="createdPerson.emit($event)"
                [invitationSource]="invitationSource"
                (close)="close.emit()"
            ></create-person-with-BA>
        </div>
    `,
    styles: [
        `
            .createPerson_container {
                padding: 20px 30px 30px 30px;
                border-width: 2px;
                border-style: solid;
                border-radius: 5px;
            }
        `
    ],
    standalone: false
})
export class CreatePersonFormComponent {
    @Output()
    createdPerson = new EventEmitter<Person>();
    @Output()
    close = new EventEmitter();
    @Input()
    invitationSource: InvitationSource;

    IconType = IconType;
    IconSize = IconSize;

    assessmentCenterData: ScheduledAssessmentDetails;

    constructor(public TR: TranslationService) {}
}
